import styles from './TransferPage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import popClose from 'assets/images/pop-close.svg';
import MainNav from '../components/main-nav/MainNav';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import Menu from './components/menu/Menu';
import { Beneficiary } from './components/beneficiary/Beneficiary';
import Amount from './components/amount/Amount';
import { Payment } from './components/payment/Payment';
import Confirm from './components/confirm/Confirm';
import Pagging from './components/pagging/Pagging';
import Transfer from './components/transfer/Transfer';
import AddBeneficary from 'views/common/add-beneficary/Add-Beneficary';
import Print from './components/print/Print';
import { commonActions } from '../../stores/_actions';

import { transcationActions } from '../../stores/_actions';
function TransferPage(props) {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const dispatch = useDispatch();
  let history = useHistory();
  let userProfile;
  const jsonData = localStorage.getItem('userProfile');
  userProfile = JSON.parse(jsonData);
  let location = useLocation();
  let [display, setCount] = useState(false);
  let [isActive, setActive] = useState(true);
  const [buttonActive, setButtonActive] = useState(true);
  let [menu, setMenu] = useState({
    beneficiary: true,
    amount: false,
    payment: false,
    confirm: false,
    transfer: false,
    print: false,
  });
  // history.push({ pathname: '/transfer', state: {"menu":menu}});
  if (location.state == undefined) {
    history.push({ pathname: '/transfer', state: { menu: menu } });
  }

  useEffect(() => {
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
  });
  let userProfile1 = useSelector((state) => state.getCustDetails.data);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile1} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              {location.state && location.state?.menu?.print ? '' : <Menu />}
              {location.state && location.state?.menu?.beneficiary ? <Beneficiary /> : ''}
              {location.state && location.state?.menu?.amount ? <Amount /> : ''}
              {location.state && location.state?.menu?.payment ? <Payment /> : ''}
              {location.state && location.state?.menu?.confirm ? <Confirm /> : ''}
              {location.state && location.state?.menu?.transfer ? <Transfer /> : ''}
              {location.state && location.state?.menu?.print ? <Print /> : ''}
              {/* {display ? (
                <div className={styles.dialogue}>
                  <div className={styles.dialogue__wrap}>
                    <img className={styles.dialogue__close} src={popClose} onClick={hidePopup} />
                    <p>{result && result.statusCode == '401' ? result.message : `Your payment has been done with ${result?.Refno}`}</p>
                    <div className={styles.dialogue__buttons}>
                      {result && result.statusCode == '401' ? 
                      <input type="submit" value="Retry" onClick={hidePopup} className={styles.LoginPage__link} /> :
                      <input type="submit" value="OK" onClick={redirect} className={styles.LoginPage__link} />}
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )} */}
            </div>
            <AddBeneficary />
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { TransferPage };
